// extracted by mini-css-extract-plugin
export default {"buttonPeConnect":"PoleEmploiButton_buttonPeConnect__gmA0y","text":"PoleEmploiButton_text__acIux"};